/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useQuery } from "@apollo/client";
import { TextField, Autocomplete } from "@mui/material";
import { ALL_EMPLOYEE_JOB_TITLES_QUERY } from "../../graphql";

const EmployeeJobTitleSelectMUI = ({
  name,
  value,
  label,
  placeholder,
  disabled,
  required,
  showAllOption,
  getValue,
  setValue,
  onChange,
}) => {
  const [formattedOptions, setFormattedOptions] = useState([]);
  const { data: { users: DistinctJobTitles = [], loading } = {} } = useQuery(
    ALL_EMPLOYEE_JOB_TITLES_QUERY,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        where: {
          jobTitle: {
            not: {
              equals: null,
            },
          },
        },
        distinct: "jobTitle",
        orderBy: [
          {
            jobTitle: "asc",
          },
        ],
      },
    }
  );

  useEffect(() => {
    if (DistinctJobTitles?.length) {
      const fOptions = DistinctJobTitles.map((item) => ({
        value: item?.jobTitle,
        label: item?.jobTitle,
      }));

      if (showAllOption) {
        fOptions.unshift({ value: "", label: "All" });
      }

      setFormattedOptions(fOptions);
    }
  }, [DistinctJobTitles, showAllOption]);

  return (
    <Autocomplete
      fullWidth
      disabled={disabled}
      getOptionLabel={(option) =>
        option.label ??
        formattedOptions.find((opt) => opt.value === value)?.label
      }
      isOptionEqualToValue={(o, v) => o.value === v}
      isRequired={required}
      loading={loading}
      options={formattedOptions}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
      size="medium"
      value={getValue(value)}
      onChange={(_, option) => {
        onChange(name, setValue(option?.value));
      }}
    />
  );
};

EmployeeJobTitleSelectMUI.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  showAllOption: PropTypes.bool,
  getValue: PropTypes.func,
  setValue: PropTypes.func,
  onChange: PropTypes.func,
};

EmployeeJobTitleSelectMUI.defaultProps = {
  name: "",
  placeholder: "",
  label: "",
  disabled: false,
  required: false,
  showAllOption: false,
  getValue: (x) => x,
  setValue: (x) => x,
  onChange: () => {},
};

export default EmployeeJobTitleSelectMUI;
